import VirtualizedTable from './VirtualizedTable';

export default VirtualizedTable;
